module.exports = __webpack_public_path__ + "img/icon-box.663bbd19.svg";